import React from "react"
import PropTypes from "prop-types"

import { UMBRAL_BUENO } from "../static"

/** Barra de progreso de 5 px; ámbar por debajo del umbral, verde por encima. */
const ProgressBar = ({ porcentaje }) => {
  const valor = Math.max(0, Math.min(100, Number(porcentaje) || 0))

  return (
    <div className="res-bar">
      <span
        className={valor < UMBRAL_BUENO ? "is-warn" : ""}
        style={{ width: `${valor}%` }}
      />
    </div>
  )
}

ProgressBar.propTypes = {
  porcentaje: PropTypes.number,
}

export default ProgressBar
